module.exports = __webpack_public_path__ + "img/GreenTick.bcc470b9.svg";